import { APP_VERSION } from "./env-constants";

/** @returns a string to represent this app in the format sphere-web-viewer/version */
export function appId(): string {
  return `sphere-web-viewer/${APP_VERSION}`;
}
